<template>
  <div>
    <header class="error-header">
      <a
        href="javascript:history.go(-1)"
        class="btn-back"
      />
    </header>
    <div class="error-img">
      <img src="../../asset/img/404.png">
    </div>
    <div class="error-desc">
      <h2>很抱歉，您要访问的页面不存在</h2>
      <p>1.您要访问的网页不存在或已被删除</p>
      <p>2.请检查您输入的网址是否正确</p>
      <p>
        您可以返回首页<i>{{ count }}</i>秒后将自动跳转首页
      </p>
    </div>
  </div>
</template>

<script>
import { getCookieAbtest, getSsrUigsParams } from '../common/js/util';

export default {
  data() {
    return {
      count: 3,
    };
  },
  mounted() {
    const self = this;
    self.timer();
    self.setUigsPara();
    const opts = getSsrUigsParams();
    self.$uigs.send(opts);
  },
  methods: {
    timer() {
      const self = this;
      setTimeout(() => {
        self.count -= 1;
        if (self.count > 0) {
          self.timer();
        } else {
          const { origin = 'https://wapv.sogou.com', search = '' } = location;
          location.href = `${origin}${search.includes('spver=1') ? '?spver=1' : ''}`;
        }
      }, 1000);
    },
    setUigsPara() {
      window.UIGS_PARA = {
        uigs_pbtag: 'A',
        pagetype: 'error',
        pageversion: 'other',
        abtest: getCookieAbtest(),
      };
    },
  },
};
</script>

<style lang="scss">
.error {
  &-header {
    height: 21px;
    padding: 18px;
    position: relative;
    .btn-back {
      display: block;
      height: 21px;
      width: 21px;
      background-image: url('../../asset/img/back.png');
      background-size: 100%;
    }
  }
  &-img {
    width: 206px;
    margin: 20px auto;
    img {
      width: 100%;
    }
  }
  &-desc {
    margin: auto;
    width: 250px;
    > h2 {
      font-size: 17px;
      font-weight: bold;
      color: #555;
      margin-bottom: 20px;
    }
    > p {
      font-size: 15px;
      color: #999;
      margin-bottom: 10px;

      &:last-of-type {
        margin-top: 20px;
      }

      > i {
        color: #e22b00;
      }
    }
  }
}
</style>
